import React from "react";

const WithdrawIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 18" fill="none">
      <path
        d="M10.1779 5.8002H14.0889C14.2762 5.79836 14.4565 5.87118 14.5899 6.00258C14.7234 6.13398 14.799 6.31313 14.8 6.5004V16.3C14.799 16.4873 14.7234 16.6665 14.5899 16.7979C14.4565 16.9293 14.2762 17.0021 14.0889 17.0002H2.71104C2.52377 17.0021 2.34348 16.9293 2.21004 16.7979C2.0766 16.6665 2.00101 16.4873 2 16.3V6.5004C2.00101 6.31313 2.0766 6.13398 2.21004 6.00258C2.34348 5.87118 2.52377 5.79836 2.71104 5.8002H6.62207"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.3999 9.96008V1.00012"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.448 2.92011L8.40005 1.00012L6.35205 2.92011"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WithdrawIcon;
